// ===============================================================
// 🌐 i18n.js — Translation Engine Only (FINAL / LOCKED - Path B)
// ===============================================================

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ---------------------------------------------------------------
// 📦 Translation files
// ---------------------------------------------------------------
import ar from "./locales/ar.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import tr from "./locales/tr.json";
import ru from "./locales/ru.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import fa from "./locales/fa.json";
import id from "./locales/id.json";
import ph from "./locales/ph.json";
import el from "./locales/el.json";
import he from "./locales/he.json";
import ku from "./locales/ku.json";

import {
  LANG_KEY,
  SUPPORTED_LANGS,
  resolveInitialLanguage,
} from "./utils/languagePref";

// ---------------------------------------------------------------
// 🚀 Init i18n (NO direction logic here)
// ---------------------------------------------------------------
i18n.use(initReactI18next).init({
  lng: resolveInitialLanguage(),
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGS,
  load: "languageOnly",
  nonExplicitSupportedLngs: true,

  resources: {
    ar: { translation: ar },
    en: { translation: en },
    de: { translation: de },
    tr: { translation: tr },
    ru: { translation: ru },
    es: { translation: es },
    fr: { translation: fr },
    it: { translation: it },
    pt: { translation: pt },
    fa: { translation: fa },
    id: { translation: id },
    ph: { translation: ph },
    el: { translation: el },
    he: { translation: he },
    ku: { translation: ku },
  },

  detection: {
    order: ["localStorage"],
    lookupLocalStorage: LANG_KEY,
    caches: [],
  },

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
